<template>
    <div class="section std gallery">
    <div class="section-container">
      <div class="content">
        <div class="container">
          <div class="row">
            <div class="col-md-12 p-0">
              <h2>{{ trans.get('public.home.industries') }}</h2>
            </div>
            <div class="col-md-6 p-0" v-for="(card, i) in 2" :key="i">
              <industrie_card :card="i" />
            </div>

          </div>

              <a class="discover-button">
                <img
                    @click="scrollDown"
                    :src="url('/media/vetrina/discover_button.svg')"
                    alt="discover btn"
                />
                <span class="discover-text">{{ trans.get('public.home.discover-materials') }}</span>
              </a>


        </div>
      </div>

    </div>
  </div>

</template>

<script>
import industrie_card from "./industrie-card";

export default {
  components: {
    industrie_card,
  },
  data() {
    return {};
  },
  mounted() {
    this.getMacroFamilies();
  },
  methods: {
    scrollDown: function () {
      fullpage_api.moveSectionDown()
    },
    getMacroFamilies: function () {
      axios({
        method: "get",
        url: window.location.origin + "/macrofamilies",
      }).then((res) => {
        this.macrofamilies = res.data[0];
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.section {
  //margin-top: 100px;
  padding-top: 50px;
  margin-bottom: 280px;
  position: relative;
}
.container {
  font-size: 1em;
  @media (min-width: 1921px){
    font-size: var(--font-size-large);
  }
  background-color: #26262a;
  display: flex;
  flex-direction: column;
  height: calc(100vh - 80px);
  width: 100%;
  max-width: 100%!important;
  padding: 0;
  .row {
    width: 90%;
    max-width: 90%;
  }
  h2 {
    color: #fff;
    padding: 0;
  }
}

.discover-button {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  bottom: -25%;
  left: 50%;
  transform: translate(-50%);
  .discover-text {
    display: inline-block;
    color: #d8d8d8;
    margin-top: 10px;

  }

  img:hover + .discover-text {
    color: var(--greenb2b);
  }
}
@media (max-width: 576px){
  .container, .content, .section-container, .section.std {
    height: 100%!important;
  }
  .section {
    padding: 25px 0;
    .section-container{
      margin: 0;
      max-width: 100%;
      .content {
        .container {
          padding: 0;
          h2 {
            font-size: 18px;
            margin-bottom: 12px;
            margin-left: 5px;
          }
          .button-section {
            margin-bottom: 25px;
            .discover-button {
              img {
                width: 61px;
                height: 61px;
              }

              .discover-text {
                font-size: 16px;
              }
            }
          }
        }
      }
    }
  }
}
@media (min-width: 1921px) {
  .section.std.gallery {
    margin-bottom: 0;
    .row {
      margin: 0 auto;
    }
    .discover-button {
      bottom: 0;
    }
  }
}

@media (min-width: 2000px) and (min-height: 800px) {
  .section.std.gallery {
    padding-top: 200px;
    margin-bottom: 400px;

    .discover-button {
      bottom: -15%;
    }
  }

}

</style>
